import type { Faq } from '@/domain/faqs/entities/faq.entity'

export type FaqSortField = keyof Faq

export interface FaqsDeleteDialogState {
  isOpen: boolean
  faqId: string | null
  faqQuestion: string
}

export const initialFaqsDeleteDialogState: FaqsDeleteDialogState = {
  isOpen: false,
  faqId: null,
  faqQuestion: '',
}

export interface FaqFormErrors {
  question?: string
  answer?: string
}
